
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import pc from './pc/mensajes.vue';
    import movil from './pc/mensajes.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: { pc, movil }
    } )
    export default class Componente extends Vue
    {
        created()
        {

        }


    }
